import { createBrowserHistory } from 'history'

export default createBrowserHistory();



// WEBPACK FOOTER //
// ./src/containers/history/index.js